export default "__VITE_ASSET__BNqfqZ2s__"